export enum PROVIDER_TYPE {
  CONVERSION = 'conversion',
  EVENT = 'event',
}

export interface ProviderConfig {
  type: PROVIDER_TYPE;
  url: string;
  params: ProviderPostbackParam[];
}

export interface ProviderParam {
  key: string;
  value: string;
  macro: string;
}

export interface ProviderPostbackParam {
  key: string;
  value: string;
}

export interface ProviderFull {
  id: number;
  accountId: number;
  name: string;
  params: ProviderParam[];
  config: ProviderConfig[];
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export type Provider = Omit<ProviderFull, 'accountId' | 'isDeleted'>;
export type ProviderCreation = Omit<
  ProviderFull,
  'accountId' | 'isDeleted' | 'createdAt' | 'updatedAt' | 'id'
> &
  Partial<Pick<ProviderFull, 'id'>>;
export type ProviderList = Pick<ProviderFull, 'id' | 'name'>;
